// extracted by mini-css-extract-plugin
export var arbiterSwatch = "_1x-3";
export var dialog = "_1x-0";
export var divClassnameSwatch = "_1x-8";
export var flexSwatch = "_1x-4";
export var header = "_1x-1";
export var styleAttributeSwatch = "_1x-7";
export var swatch = "_1x-2";
export var textHeaderSwatch = "_1x-5";
export var webSwatch = "_1x-6";